<script lang="ts" setup>
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import Page from '~/enums/page'
import formatter from '~/helpers/formatter'
import { useCartStore } from '~/store/cart'

const model = defineModel<boolean>()

const biominsBrandPath = `${Page.Brands}biomins-321/`
const specialOfferPath = `${Page.SpecialOffers}uchastvuyte-v-rozygryshe-back2school-54/`
const superminsBrandPath = `${Page.Brands}supermins-204/`

const cartStore = useCartStore()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Билеты #Back2school
    </template>

    <p>Получите шанс выиграть ценные призы за&nbsp;каждые {{ formatter.formatPrice(cartStore.backToSchoolStepAmountInKopecks, true) }}&nbsp;₽ в&nbsp;чеке, заказав хотя&nbsp;бы 1&nbsp;продукт <a :href="superminsBrandPath" target="_blank">Supermins</a> или <a :href="biominsBrandPath" target="_blank">Biomins</a>. <a :href="specialOfferPath" target="_blank">Подробнее</a>.</p>

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
